// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as StatsTable2 from "../components/StatsTable2.bs.js";

var levelCols = [
  StatsTable2.col(false, undefined, (function (param, param$1) {
          return param$1.t("Param");
        }), undefined, (function (param, param$1, param$2) {
          return String(param[0]);
        }), undefined, undefined, undefined, (function (param, param$1, param$2) {
          return param[0];
        }), undefined, 100, undefined, undefined),
  StatsTable2.col(true, undefined, (function (param, param$1) {
          return param$1.t("% Use");
        }), undefined, (function (param, ctx, param$1) {
          return Global.formatPct2(undefined, Global.f(param[1]) / Global.f(ctx));
        }), undefined, undefined, undefined, (function (param, param$1, param$2) {
          return param[1];
        }), undefined, 100, undefined, undefined),
  StatsTable2.col(true, undefined, (function (param, param$1) {
          return param$1.t("Avg.");
        }), undefined, (function (param, param$1, param$2) {
          return Global.toFixed(undefined, Global.f(param[2]) / Global.f(param[1]));
        }), undefined, undefined, undefined, (function (param, param$1, param$2) {
          return Global.f(param[2]) / Global.f(param[1]);
        }), undefined, 100, undefined, undefined)
];

var tierCols = [
  StatsTable2.col(false, undefined, (function (param, param$1) {
          return param$1.t("Param");
        }), undefined, (function (param, param$1, param$2) {
          var key = param[0];
          var tier = key / 8 | 0;
          var cost = key % 8 + 1 | 0;
          return String(tier) + "*  " + String(cost) + "g";
        }), undefined, undefined, undefined, (function (param, param$1, param$2) {
          return param[0];
        }), undefined, 100, undefined, undefined),
  StatsTable2.col(true, undefined, (function (param, param$1) {
          return param$1.t("% Use");
        }), undefined, (function (param, ctx, param$1) {
          return Global.formatPct2(undefined, Global.f(param[1]) / Global.f(ctx));
        }), undefined, undefined, undefined, (function (param, param$1, param$2) {
          return param[1];
        }), undefined, 100, undefined, undefined),
  StatsTable2.col(true, undefined, (function (param, param$1) {
          return param$1.t("Avg.");
        }), undefined, (function (param, param$1, param$2) {
          return Global.toFixed(undefined, Global.f(param[2]) / Global.f(param[1]));
        }), undefined, undefined, undefined, (function (param, param$1, param$2) {
          return Global.f(param[2]) / Global.f(param[1]);
        }), undefined, 100, undefined, undefined)
];

var costCols = [
  StatsTable2.col(false, undefined, (function (param, param$1) {
          return param$1.t("Param");
        }), undefined, (function (param, param$1, param$2) {
          var key = param[0];
          return String(Math.imul(key, 5)) + "-" + String(Math.imul(key, 5) + 4 | 0) + "g";
        }), undefined, undefined, undefined, (function (param, param$1, param$2) {
          return param[0];
        }), undefined, 100, undefined, undefined),
  StatsTable2.col(true, undefined, (function (param, param$1) {
          return param$1.t("% Use");
        }), undefined, (function (param, ctx, param$1) {
          return Global.formatPct2(undefined, Global.f(param[1]) / Global.f(ctx));
        }), undefined, undefined, undefined, (function (param, param$1, param$2) {
          return param[1];
        }), undefined, 100, undefined, undefined),
  StatsTable2.col(true, undefined, (function (param, param$1) {
          return param$1.t("Avg.");
        }), undefined, (function (param, param$1, param$2) {
          return Global.toFixed(undefined, Global.f(param[2]) / Global.f(param[1]));
        }), undefined, undefined, undefined, (function (param, param$1, param$2) {
          return Global.f(param[2]) / Global.f(param[1]);
        }), undefined, 100, undefined, undefined)
];

function Tc2Other2Tab(Props) {
  var group = Props.group;
  var keyFn = React.useCallback((function (param) {
          return String(param[0]);
        }), []);
  return React.createElement("div", undefined, React.createElement("h2", {
                  className: "mb-2 font-montserrat font-medium text-xl"
                }, "Levels"), React.createElement(StatsTable2.make, {
                  cols: levelCols,
                  data: group.levels,
                  context: group.count,
                  keyFn: keyFn,
                  stickyColCount: 1,
                  top: "t0",
                  defaultSortIdx: 0
                }), React.createElement("h2", {
                  className: "mt-8 mb-2 font-montserrat font-medium text-xl"
                }, "Unit Tiers"), React.createElement(StatsTable2.make, {
                  cols: tierCols,
                  data: group.unitTiers,
                  context: group.count,
                  keyFn: keyFn,
                  stickyColCount: 1,
                  top: "t0",
                  defaultSortIdx: 0
                }), React.createElement("h2", {
                  className: "mt-8 mb-2 font-montserrat font-medium text-xl"
                }, "Board value"), React.createElement(StatsTable2.make, {
                  cols: costCols,
                  data: group.costDistribution,
                  context: group.count,
                  keyFn: keyFn,
                  stickyColCount: 1,
                  top: "t0",
                  defaultSortIdx: 0
                }));
}

var make = Tc2Other2Tab;

export {
  levelCols ,
  tierCols ,
  costCols ,
  make ,
  
}
/* levelCols Not a pure module */
